import { Compass } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/**
 * Tela 404 graciosa (defaultNotFoundComponent do TanStack Router): URL desconhecida não fica em branco.
 * Usa link nativo para o início (robusto mesmo fora do fluxo normal de roteamento).
 */
export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="flex w-full max-w-md flex-col items-center gap-4 text-center">
        <span
          aria-hidden="true"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-background-subtle text-foreground-muted"
        >
          <Compass className="h-6 w-6" />
        </span>
        <div className="flex flex-col gap-1">
          <h1 className="text-lg font-semibold text-foreground-primary">{t('notFound.title')}</h1>
          <p className="text-sm text-foreground-muted">{t('notFound.description')}</p>
        </div>
        <a
          href="/"
          className="inline-flex h-10 items-center justify-center rounded-md bg-action-primary px-4 text-sm font-medium text-foreground-on-action hover:bg-action-primary-hover"
        >
          {t('notFound.home')}
        </a>
      </div>
    </div>
  )
}
